import { createAction, props } from '@ngrx/store';
import { IUtmState } from './utm.state';
// import { IUtmModel } from '@partners/utm';

export class UtmActions {
  static reset = createAction('[Utm] Reset State');
  static loadParams = createAction('[Utm] Load Url Params', props<{ model: IUtmState }>());
}
